import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let StarshipModifications = class StarshipModifications extends VuexModule {
    constructor() {
        super(...arguments);
        this.starshipModifications = [];
        this.cachedVersion = 0;
    }
    async fetchStarshipModifications() {
        const { data: starshipModifications, cachedVersion } = await fetchFromCache(this, 'starshipModifications', 'starshipModification');
        return { starshipModifications, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['starshipModifications', 'cachedVersion'] })
], StarshipModifications.prototype, "fetchStarshipModifications", null);
StarshipModifications = __decorate([
    Module({ namespaced: true, name: 'starshipModifications' })
], StarshipModifications);
export default StarshipModifications;
